module.exports = __webpack_public_path__ + "static/img/15.090a52f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carrossel/15.png
// module id = 5AXk
// module chunks = 4